export default {
  "base": "/",
  "title": "React Trace",
  "description": "A development-time React inspector that helps you identify rendered components, resolve their source locations, and run source-aware actions.",
  "icon": "/favicon.svg",
  "route": {
    "cleanUrls": true
  },
  "themeConfig": {
    "darkMode": true,
    "footer": {
      "message": "MIT License"
    },
    "nav": [
      {
        "text": "Docs",
        "link": "/guide/index.html"
      }
    ],
    "sidebar": {
      "/": [
        {
          "text": "Getting Started",
          "items": [
            {
              "text": "Introduction",
              "link": "/guide/index.html"
            },
            {
              "text": "Installation",
              "link": "/guide/installation.html"
            },
            {
              "text": "Configuration",
              "link": "/guide/configuration.html"
            },
            {
              "text": "Production Stubs",
              "link": "/guide/production-stubs.html"
            }
          ],
          "collapsed": false,
          "collapsible": true
        },
        {
          "text": "Plugins",
          "items": [
            {
              "text": "Overview",
              "link": "/plugins/index.html"
            },
            {
              "text": "Preview",
              "link": "/plugins/preview.html"
            },
            {
              "text": "Comments",
              "link": "/plugins/comments.html"
            },
            {
              "text": "Copy to Clipboard",
              "link": "/plugins/copy-to-clipboard.html"
            },
            {
              "text": "Open Editor",
              "link": "/plugins/open-editor.html"
            }
          ],
          "collapsed": false,
          "collapsible": true
        },
        {
          "text": "Extending",
          "items": [
            {
              "text": "Creating Plugins",
              "link": "/extending/plugin-api.html"
            },
            {
              "text": "UI Components",
              "link": "/extending/ui-components.html"
            }
          ],
          "collapsed": false,
          "collapsible": true
        }
      ]
    },
    "socialLinks": [
      {
        "icon": "github",
        "mode": "link",
        "content": "https://github.com/buzinas/react-trace"
      },
      {
        "icon": "x",
        "mode": "link",
        "content": "https://x.com/vbuzinas"
      }
    ]
  },
  "lang": "en",
  "locales": [],
  "logo": {
    "light": "/logo.svg",
    "dark": "/logo-dark.svg"
  },
  "logoText": "",
  "logoHref": "",
  "multiVersion": {
    "default": "",
    "versions": []
  },
  "search": {},
  "markdown": {
    "showLineNumbers": false,
    "defaultWrapCode": false,
    "shiki": {}
  }
}